import React, {useContext} from 'react';
import logo from '../../assets/images/logo/logo.jpg';
import {Link, useLocation, useNavigate} from "react-router-dom";
import Flag from 'react-world-flags';
import Nav from "../Nav/Nav";
import {ChangeLangContext, LangContext} from "../../App";

const Menu = () => {
    const changeLang = useContext(ChangeLangContext)
    const lang = useContext(LangContext)
    const navigate = useNavigate();
    const location = useLocation();

    const switchLang = (newLang) => {
        changeLang(newLang);
        const path = location.pathname;
        const parts = path.split('/').filter(Boolean);
        if (parts.length && ['en','de','ru'].includes(parts[0])) {
            parts[0] = newLang;
        } else {
            parts.unshift(newLang);
        }
        navigate('/' + parts.join('/'));
    }

    return (
        <div className='menu' style={{zIndex:100}}>
            <div className="top-side">
                <div className="center-wrapper justify-content-end">
                    <div className="lengs">
                        <div className='selected-lang' onClick={()=> switchLang('en')}>
                            <Flag code="us" height="10" />
                        </div>
                        <div className='selected-lang' onClick={()=> switchLang('de')}>
                            <Flag code="de" height="10" />
                        </div>
                        <ul className="dropdown">
                            <li><Flag code="us" height="30" /></li>
                            <li><Flag code="de" height="30" /></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="center-wrapper justify-content-between">
                <Link to={`/${lang}`} className='logo'>
                    <img src={logo} alt="Ayrarat logo"/>
                </Link>
                <Nav/>
            </div>
        </div>
    );
};

export default Menu;